<template>
    <div>
        <VerifySignUpUser />
    </div>
</template>

<script>
import VerifySignUpUser from "@/components/Auth/Home/verifySignUp.vue"
export default {
    name: "verify_signup",
    components: {
        VerifySignUpUser
    }
}
</script>

<style lang="scss" scoped></style>